import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { customHits } from './custom/custom-hits';
import { customSearchBox } from './custom/custom-search-box';
import { displayOnClick } from './dom/display-on-click';
import { hideOnClickOutside } from './dom/hide-on-click-outside';
import { hideOnlyIfEscKey } from './dom/hide-on-esc-key';

/**
 * Mets en place la recherche Algolia
 *
 */
const initializeSearch = () => {
  const algoliaAppId = $('div#millesime-container').data('algolia-app-id');
  const algoliaApiKey = $('div#millesime-container').data('algolia-api-key');
  const algoliaIndex = $('div#millesime-container').data('algolia-index');
  const placeholder = $('div#millesime-container').data('search-placeholder');

  if (
    typeof algoliaAppId === 'undefined' ||
    typeof algoliaApiKey === 'undefined' ||
    typeof algoliaIndex === 'undefined'
  ) {
    console.error(
      'You must provide the Algolia App ID, API key and index for the search module to work.'
    );
    return;
  }

  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey);

  const search = instantsearch({
    indexName: algoliaIndex,
    searchClient,
  });

  search.addWidgets([
    customSearchBox({
      container: '#millesime-container',
      placeholder,
      autofocus: true,
      showSubmit: true,
      inputId: 'chassis',
    }),
    customHits({
      input: '#chassis',
      dataContainer: '.resultData',
      detailContainer: '#hits',
      hitContainer: '#hit-container',
      // Pour ajouter des classes supplémentaires aux div contenant les suggestions,
      // les ajouter dans la propriété ci-dessous, séparées par un espace.
      customClasses: '',
    }),
  ]);

  search.start();
};

document.addEventListener('DOMContentLoaded', () => {
  initializeSearch();
  hideOnClickOutside('#algolia', '#hit-container');
  hideOnlyIfEscKey('#chassis', '#hit-container');
  displayOnClick('#chassis', '#hit-container');
});
